import type { ReactNode } from 'react'
import { generatePath, NavLink } from 'react-router'

export const OpsVettingHeader = ({
	endSlot,
	vettingId,
	title,
	steps
}: {
	endSlot: ReactNode
	vettingId: number
	title: string
	steps: readonly { label: string; path: string }[]
}) => {
	return (
		<div className='relative flex flex-col gap-2 pt-10'>
			<div className='flex w-full flex-row items-center justify-between gap-2'>
				<h1 className='font-bold text-display-xs text-neutral-900'>
					{title}
				</h1>
				<span>{endSlot}</span>
			</div>
			<div className='relative flex w-full gap-2 border-neutral-200 border-b pb-3'>
				{steps.map((step) => (
					<NavLink
						className={({ isActive }) =>
							`cursor-pointer px-1 font-semibold text-base underline decoration-2 underline-offset-[18px] transition-all duration-300 ${
								isActive
									? 'text-neutral-700 decoration-neutral-700'
									: 'text-neutral-500 decoration-transparent hover:text-neutral-600'
							}`
						}
						key={step.label}
						to={generatePath(step.path, { id: vettingId })}
					>
						{step.label}
					</NavLink>
				))}
			</div>
		</div>
	)
}
